export const DEFAULT_STORY_TIME = {
    value: 24,
    unit: 'hours'
}
export const DEFAULT_SUGGESTION_TIME = {
    value: '60',
    unit: 'minutes'
}